import React from "react";

function VideoSJ() {
  return (
      <div className="resp-video">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Y8Wp3dafaMQ&autoplay=1" srcDoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%; background:#000}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/xl-XjjI-d3Y?start=844><img style='filter: invert(99%) sepia(1%) saturate(4349%) hue-rotate(189deg) brightness(118%) contrast(80%); transform: scale(.6);' src='https://www.crimsondevils.com/static/media/logo.540e6dd586e0f82c198defe0e0596c61.svg' alt='Austin Stoner Jam 2022 - Sampler Vol 1'><span>▶</span></a>" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Austin Stoner Jam 2022 - Sampler Vol 1"></iframe>
      </div>
  )
}

export default VideoSJ
